import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { Computer, Print } from '@material-ui/icons';
import { useStyles } from './styles';

export const ASSESSMENT_TYPE = {
  ONLINE: 'online',
  PRINTED: 'printed',
};

export function AssessmentTypeToggle({ value, onChange }) {
  const classes = useStyles();

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      size="small"
      onChange={(_, newValue) => newValue && onChange(newValue)}
      className={classes.typeToggleGroup}
    >
      <ToggleButton value={ASSESSMENT_TYPE.ONLINE} className={classes.typeToggleButton}>
        <Computer fontSize="small" className={classes.typeToggleIcon} />
        Online
      </ToggleButton>
      <ToggleButton value={ASSESSMENT_TYPE.PRINTED} className={classes.typeToggleButton}>
        <Print fontSize="small" className={classes.typeToggleIcon} />
        Impressa
      </ToggleButton>
    </ToggleButtonGroup>
  );
}